import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import faker from 'faker';
import mockData from '../mockData'
import GenericTitleP from '../../titles/GenericTitleP';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  interaction: {
    mode: 'index',
    intersect: false,
  },
  stacked: false,
  plugins: {
    title: {
      display: true,
      text: 'Sales Chart Example',
    },
  },
  scales: {
    y: {
      type: 'linear',
      display: true,
      position: 'left',
    },
    y1: {
      type: 'linear',
      display: false,
      position: 'right',
      grid: {
        drawOnChartArea: false,
      },
    },
  },
};

const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];
const labels = Object.keys(mockData[0].dates).map(x => `${monthNames[(new Date(x).getMonth())]} ${(new Date(x).getFullYear())}`)

// console.log("asd => ",labels.map(() => faker.datatype.number({ min: -1000, max: 1000 })))
// console.log("llolol => ",Object.values(mockData[0].dates).map(x => Object.values(mockData[0].dates)))

let newArr = [];

for (let i = 0; i < mockData.length; i++){
  let color = "rgba(" + Math.ceil(Math.random()*254)  +"," + Math.ceil(Math.random()*254) +","+ Math.ceil(Math.random()*254);

  newArr.push({
    label: "item-"+(mockData[i].id),
    data: Object.values(mockData[i].dates),
    borderColor: color +",1)",
    backgroundColor: color+",0.5",
  })
}

export const data = {
  labels,
  datasets: newArr
};



const LineChartComponent = () => {
  return <div className='d-none d-md-block py-4' >
      <GenericTitleP>Sales Per Item (Quarterly)</GenericTitleP>
      <Line options={options} data={data} />
    </div>
}

export default LineChartComponent